import React from "react";
import PT from "prop-types";
import DOMPurify from 'dompurify';

import "./search-box.m.css";

class SearchBoxBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        name: "",
        inputs:""
    };
  }
  handleChange = (e) => {
    const { value } = e.target
    const cleanInput = DOMPurify.sanitize(value);
    this.setState({
      inputs: cleanInput
    })
    this.setState({
        name: cleanInput.replace(/ /g, "-")
    })

  }

  handleSubmit = (event) => {
    event.preventDefault();
    window.location = `/search?q=${this.state.name}`;
  }
  render() {
    return (
      <form  styleName="input-group" onSubmit={this.handleSubmit} method="get">
          <input
            id={this.props.id}
            ref={this.props.innerRef}
            name='name'
            value={this.state.inputs}
            styleName="searchpage-search"
            placeholder="Kirjoita hakusana ..."
            required
            onChange={e => this.handleChange(e)}
          />
        <span className="">
            <button type="submit" styleName="btn-search">
              <i className="ri-search-line"></i>{/*<span styleName="search-text">Search</span>*/}
            </button>
        </span>
      </form>
    );
  }
}
export { SearchBoxBase };

SearchBoxBase.propTypes = {
  formStyle: PT.object,
  initialStyle: PT.object,
  searchStyle: PT.object,
  id: PT.string,
  toggleSearchForm: PT.func,
  innerRef: PT.object
};
